// BaakPembayaran adalah alias untuk PembayaranMahasiswa
// dengan interface yang sama namun diakses dari menu BAAK
import PembayaranMahasiswa from '../Finance/PembayaranMahasiswa';

export default PembayaranMahasiswa;
